import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NotificationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 20"
    >
      <path
        d="M17.4562 14.349L16.4584 12.3527V7.74499C16.4584 4.15449 13.65 1.14915 10.1978 1.04532C8.43474 0.994069 6.76683 1.63815 5.50299 2.86499C4.23833 4.09224 3.54174 5.73849 3.54174 7.50082V12.3535L2.54441 14.3489C2.31699 14.8047 2.34099 15.3352 2.60866 15.7682C2.87633 16.2011 3.33983 16.4591 3.84849 16.4591H6.93833C7.22908 17.8831 8.49116 18.9582 10.0001 18.9582C11.509 18.9582 12.771 17.8831 13.0617 16.4591H16.1516C16.661 16.4591 17.1249 16.2003 17.3927 15.7665C17.6604 15.3336 17.684 14.8032 17.4562 14.349ZM10.0001 17.7083C9.18674 17.7083 8.49966 17.1845 8.24049 16.4592H11.7595C11.5003 17.1845 10.8132 17.7083 10.0001 17.7083ZM16.329 15.1098C16.3062 15.1472 16.2525 15.2091 16.1516 15.2091H3.84858C3.74766 15.2091 3.69474 15.1472 3.67199 15.1106C3.64924 15.0739 3.61749 14.9982 3.66266 14.9072L4.72591 12.7799C4.76941 12.6937 4.79183 12.5976 4.79183 12.5007V7.50074C4.79183 6.0794 5.35374 4.75174 6.37341 3.76215C7.35408 2.8104 8.63574 2.29199 9.99849 2.29199C10.0522 2.29199 10.1063 2.29282 10.1604 2.2944C12.9436 2.37824 15.2084 4.82332 15.2084 7.74482V12.4999C15.2084 12.5967 15.2312 12.6936 15.2743 12.7798L16.338 14.9079C16.3836 14.9982 16.3517 15.0732 16.329 15.1098Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NotificationIcon.displayName = 'NotificationIcon';
